import * as React from 'react';
import { SVGProps } from 'react';

const IconAxesRotateSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m16 3 5 5-5 5V9a7 7 0 0 0-7 7h4l-5 5-5-5h4a9 9 0 0 1 9-9V3ZM3 7h3a1 1 0 0 0 1-1V3h2v3a3 3 0 0 1-3 3H3V7Z" />
  </svg>
);
export default IconAxesRotateSizeM;
